'use client';

import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Slider from 'react-slick';
import LandingEventCard from '../../LandingEventCard';
import EventDTO from '../../../models/event';
import useIsMobile from '../../../hooks/useIsMobile';
import getToastColor from '../../../utils/getToastColor';
import getToastText from '../../../utils/getToastText';
import { getSafeLocation } from '../../../utils/safeLocation';
import { inheritedSearchForTarget } from '../../../utils/eventReferral';

interface Props {
  cards: EventDTO[];
  handleEventSelect?: (eventId: string) => void;
}

const CarrouselCards: React.FC<Props> = ({ cards, handleEventSelect }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3.1,
    slidesToScroll: 1,
    arrows: !useIsMobile(),
    autoplay: !handleEventSelect,
    autoplaySpeed: 5000,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  };

  const onSelect = (eventId: string) => {
    if (handleEventSelect) {
      handleEventSelect(eventId);
    } else {
      const { pathname, search } = getSafeLocation();
      const target = `/events/${eventId}`;
      window.location.assign(`${target}${inheritedSearchForTarget(pathname, search, target)}`);
    }
  };
  // Bleed by the slides' own padding (p-2 lg:p-4) so card edges line up with the content;
  // any wider overruns the shell's px-2 on mobile and scrolls the page sideways.
  return (
    <div className='-mx-2 lg:-mx-4'>
      <Slider {...settings}>
        {cards.map((card, index) => (
          <div key={index} className='w-[90%] lg:w-full relative p-2 lg:p-4'>
           <LandingEventCard event={card} onSelect={onSelect} textButton={handleEventSelect ? 'Ver evento' : 'Adquirir entradas'} textToast={handleEventSelect ? getToastText(card.public_status) : ''} colorToast={handleEventSelect ? getToastColor(card.public_status) : ''}/>
          </div>))}
      </Slider>
    </div>
  );
};

export default CarrouselCards;
